// extracted by mini-css-extract-plugin
export default {"container":"po-z","ratingLayout":"qo-z","ratingLabel":"ro-z","nonInteractiveRatingLabel":"so-z"};